import { canUseDom } from '@sainsburys-tech/boltui-utils'
import { gethostPath } from '../helpers/ContentHelper'
import { getCleanPath, isMaskedHabitatPath } from '../helpers/pathCheck'
import { ARGOS_CARD_COOKIE } from '../helpers/abTestHelper'
import getHeaders from '../helpers/getHeaders'

const urlFormat = (fullLocation, variantTests = []) => {
  const path = fullLocation.split('/')[1] && fullLocation.split('/')[1]

  // e.g. /inspiration -> /features/inspiration
  if (process.env.BRAND === 'habitat' && path && isMaskedHabitatPath(`/${path}`)) {
    return `/features${fullLocation.split('?')[0]}`
  }

  // help page magnolia point actually is `/features/help/...`
  if (path && path === 'help') {
    if (fullLocation.substr(-1) === '/') fullLocation = fullLocation.slice(0, -1)
    const helpLocation = fullLocation
      .split('/')
      .slice(2)
      .join('/')
    return `/features/${helpLocation}`
  }

  // a/b tests
  let variantUrl = ''
  variantTests.forEach((test) => {
    const { testName, testVal } = test

    // ARGOS CARD A/B Test
    if (testName === ARGOS_CARD_COOKIE && fullLocation.split('/')[2] && fullLocation.split('/')[2] === 'variants') {
      variantUrl = `/events/variants/${testVal}`
    }
  })
  if (variantUrl) return variantUrl

  // default cms path
  return fullLocation.split('?')[0]
}

// Habitat response has different structure so format it to argos structure until argos response is migrated to new format
const formatHabitatCmsData = (response) => {
  return {
    meta: response.meta,
    template: {
      data: [
        {
          type: response.type,
          id: response.id,
          desc: response.desc,
          attributes: response.attributes,
        },
        ...response.data,
      ],
    },
  }
}

async function fetchCmsApi(action, cookies = {}) {
  const { historyData, location, timestamp, variantTests } = action
  // if data is already in state
  const apiLocation = getCleanPath(location)

  const canUseHistoryState = canUseDom() && historyData && historyData[apiLocation]
  if (canUseHistoryState) {
    return { data: historyData[apiLocation], status: 200 }
  }

  const timestampParam = timestamp ? `?for_date=${timestamp}` : ''
  const url = `${gethostPath()}global-api/cms`
  const fullUrl = `${url}${urlFormat(location, variantTests)}${timestampParam}`
  const res = await fetch(fullUrl, getHeaders(cookies))
  let data
  try {
    data = await res.json()
  } catch (err) {
    data = {}
  }

  const resObject = {
    data: process.env.BRAND === 'habitat' ? formatHabitatCmsData(data) : data,
    status: res.status,
    statusText: res.statusText,
  }

  return resObject
}

export { urlFormat, fetchCmsApi }
